<template>
  <div>
    <graph-skeleton :height="355" class="mx-3" v-if="report.length === 0"></graph-skeleton>
    <div v-else id="reportChart">
      <highcharts :options="options" ref="highcharts"></highcharts>
    </div>
  </div>
</template>

<script>
import { getPrettyStatName, formatStat, getFormattedDate } from '@/reports/components/ReportUtils'
import { getTooltipHTML, getStyledGraphOptions } from '@/reports/components/graphs/ReportGraphUtils'

export default {
  props: {

  },
  data () {
    return {
      report: [
        [5, 3, 7, 2],
        [2, 2, 2, 1],
        [3, 4, 3, 9],
        [5, 3, 7, 2],
        [2, 2, 2, 1]
      ]
    }
  },
  methods: {
    getBlankDataArray (size) {
      let arr = []
      for (let a = 0; a < size; a++) {
        arr.push({ data: [] })
      }
      return arr
    }
  },
  computed: {
    series () {
      let series = []
      //calculate running total
      for (let x = 0; x < this.report[0].length; x++) {
        let subSeries = []
        let runningTotalY = 0
        for (let y = 0; y < this.report.length; y++) {
          subSeries.push({
            y: this.report[y][x],
            runningTotalY: runningTotalY
          })
          runningTotalY += this.report[y][x]
        } 
        series.push(subSeries)
      }

      //we've calculated the running total, now we need to reformat the data
      let newSeries = this.getBlankDataArray(series[0].length)
      for (let x = 0; x < series.length; x++) {
        for (let y = 0; y < series[0].length; y++) {
          newSeries[y].data[x] = series[x][y]
        }
      }

      return newSeries
    },
    options () {
      let self = this
      let options = {
        chart: {
          backgroundColor: 'white',
          type: 'column',
          height: 300,
          style: {
            fontFamily: 'Gilroy, Helvetica, sans-serif'
          },
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            borderWidth: 0,
            groupPadding: 0.35,
          }
        },
        title: {
          text: '',
        },
        xAxis: {
          title: false,
          categories: ['Mon', 'Tues', 'Wed', 'Thurs']
        },
        yAxis: {
          title: false,
          endOnTick: false,
        },
        legend: {
          enabled: false
        },
        colors: [
          '#FCA44E',
          '#F6CE63',
          '#C9F38A',
          '#B1EF94',
          '#7BE9AE'
        ],
        series: this.series,
        tooltip: {
          useHTML: true,
          borderColor: '#1C1D29',
          backgroundColor: '#1C1D29',
          borderRadius: 5,
          followPointer: false,
          formatter: function () {
            return '<div style="font-size: 12px; font-weight: 500;" class="text-light">20% of users</div><div style="font-size: 15px; color:' + this.point.color + ';">' + this.point.runningTotalY + ' to ' + this.point.stackY + ' session depth</div>'
          }
        },
      }
      return _.merge(options, getStyledGraphOptions())
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/reports/components/graphs/SessionDepthStackedBarGraph.vue